import { createContext, type ReactNode, useContext } from 'react';

const PortalContainerContext = createContext<HTMLElement | null>(null);

/** Provides the library-owned DOM element used by portalled UI components. */
export function PortalContainerProvider({
  children,
  portalContainer,
}: {
  children: ReactNode;
  portalContainer: HTMLElement | null;
}): ReactNode {
  return (
    <PortalContainerContext.Provider value={portalContainer}>
      {children}
    </PortalContainerContext.Provider>
  );
}

/** Returns the library-owned DOM element used by portalled UI components. */
export function usePortalContainer(): HTMLElement | null {
  return useContext(PortalContainerContext);
}
